// extracted by mini-css-extract-plugin
export default {"parametrosInicial":"ParametrosConsulta_parametrosInicial__Fh7KT"};